<h5>Tarefas de protocolos </h5>

<div class="container">
  <div ngbAccordion>
    <div ngbAccordionItem >
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="title">Recusar protocolos aguardando validação</button>
        </h2>
      <div ngbAccordionCollapse>
			<div ngbAccordionBody>
      <ng-template>
        <div class="row">
        </div>
        <div class="row">
          <div class="submit col-auto">
            <button ngbTooltip="Cancela os protocolos que estejam 'Aguardando validação' há mais de 10 minutos." placement="top"  type="button" (click)="cancelarProtocolosEmValidacao()" class="btn btn-success no-margin">Recusar protocolos</button>
          </div>
        </div>    
      </ng-template>
    </div>
    </div>
    </div>
  </div>
</div>